export default "mutation AddToDigitalCart($sku:String!,$quantity:Int!){data:addToDigitalCart(sku:$sku,quantity:$quantity){error}}"